import {
    SET_DEED_MAP_DETAILS,
    IntendedTitlesTypes,
    DocsAvailabilityDetailsType,
    SelectedCopiesType,
    UnavailableDocsType
} from './Types';

import { IPurchaseDeedReducerState, PurchaseActionType } from './PurchaseDeedTypes';

const defaultState: IPurchaseDeedReducerState = {
    isFetchingPurchaseDeedDetails: false,
    fetchingPurchaseDeedDetailsError: null,
    purchaseDeedDetails: [],
    unavailableDocs: [],
    intendedTitles: [],
    siteCardMapDetails: {
        siteCard: null,
        layer: null,
        baseLayer: null
    },
    selectedPurchaseDeeds: []
};

export default function reducer(
    state: IPurchaseDeedReducerState = defaultState,
    action: PurchaseActionType
) {
    switch (action.type) {
        case IntendedTitlesTypes.SET:
            return {
                ...state,
                intendedTitles: action.payload
            };
        case IntendedTitlesTypes.UPDATE:
            const newIntendedTitles = [...state.intendedTitles];
            const idx = newIntendedTitles.indexOf(action.payload);
            newIntendedTitles.splice(idx, 1);
            return {
                ...state,
                intendedTitles: newIntendedTitles
            };
        case IntendedTitlesTypes.RESET:
            return {
                ...state,
                intendedTitles: []
            };
        case DocsAvailabilityDetailsType.REQUEST:
            return {
                ...state,
                isFetchingPurchaseDeedDetails: true
                // siteTitleNumbers: action.siteTitleNumbers
            };
        case DocsAvailabilityDetailsType.SUCCESS:
            return {
                ...state,
                isFetchingPurchaseDeedDetails: false,
                purchaseDeedDetails: [...state.purchaseDeedDetails, ...action.purchaseDeedDetails],
                fetchingPurchaseDeedDetailsError: null
            };
        case DocsAvailabilityDetailsType.NEXT:
            return {
                ...state,
                isFetchingPurchaseDeedDetails: false
            };
        case DocsAvailabilityDetailsType.FAILURE:
            return {
                ...state,
                isFetchingPurchaseDeedDetails: false,
                fetchingPurchaseDeedDetailsError: action.error
            };
        case DocsAvailabilityDetailsType.RESET:
            return {
                ...state,
                purchaseDeedDetails: [],
                fetchingPurchaseDeedDetailsError: null
            };
        case SET_DEED_MAP_DETAILS: {
            return {
                ...state,
                siteCardMapDetails: action.siteCardMapDetails
            };
        }
        case SelectedCopiesType.ADD: {
            return {
                ...state,
                selectedPurchaseDeeds: [...state.selectedPurchaseDeeds, ...action.payload]
            };
        }
        case SelectedCopiesType.REMOVE: {
            const copySelectedPurchaseDeeds = [...state.selectedPurchaseDeeds];
            const updatedSelectedPurchaseDeeds = copySelectedPurchaseDeeds.filter(doc => {
                const found = action.payload.find(item => item.id === doc.id);
                const result = found ? false : true;
                return result;
            });
            return {
                ...state,
                selectedPurchaseDeeds: updatedSelectedPurchaseDeeds
            };
        }
        case SelectedCopiesType.RESET: {
            return {
                ...state,
                selectedPurchaseDeeds: []
                // purchaseDeedPaymentMethod: ''
            };
        }
        case UnavailableDocsType.SET_UNAVAILABLE_DOCS: {
            return {
                ...state,
                unavailableDocs: [...state.unavailableDocs, ...action.payload]
            };
        }
        case UnavailableDocsType.RESET_UNAVAILABLE_DOCS: {
            return {
                ...state,
                unavailableDocs: []
            };
        }
        default:
            return state;
    }
}
